import React from "react";
import { Navigate } from "react-router-dom";
import { useUserContext } from "../context/UserContext";

/**
 * Patient questionnaire routes require the PATIENT realm role (API enforces the same).
 */
const RequirePatientRole = ({ children }) => {
  const { roles } = useUserContext();
  const upper = (roles || []).map((r) => String(r || "").toUpperCase());
  if (!upper.includes("PATIENT")) {
    return <Navigate to="/403" replace />;
  }
  return children;
};

export default RequirePatientRole;
